import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { LoadContext } from "@/context/LoadContext";
import { Preloader } from "@/components/Preloader";
import { Cursor } from "@/components/Cursor";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.lenis = null;
    };
  }, []);

  return (
    <div className="App grain-overlay">
      <LanguageProvider>
        <LoadContext.Provider value={ready}>
          <BrowserRouter>
            <Cursor />
            <Preloader onReady={() => setReady(true)} />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <Footer />
            <ChatWidget />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </LoadContext.Provider>
      </LanguageProvider>
    </div>
  );
}

export default App;
